export const downloadFileUtil = (file) => {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(file.blob);
    a.setAttribute('download', `${file.fileName}`);
    a.setAttribute('style', 'display:none');
    a.click();
    URL.revokeObjectURL(a.href);
};
export const getFileName = (disposition) => {
    let filename = '';
    if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches !== null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }
    filename = filename.trim();
    if (filename.includes('UTF-8')) {
        filename = filename.replace('UTF-8', '');
        filename = decodeURIComponent(filename);
    }
    return filename;
};
//# sourceMappingURL=file-download.util.js.map